<template>
  <V2MoleculesPopover
    type="info"
    size="large"
    class="relative"
    theme="card"
    init-pos-x="left"
    init-pos-y="bottom"
    popover-class="pt-3"
    :bottom-offset="0"
    :top-offset="0"
    :data-testid="dataTestid"
  >
    <div class="flex gap-3">
      <img
        :src="`${author?.image}?w=96&h=96`"
        :alt="author?.name ?? 'author'"
        width="40"
        height="40"
        class="wh-10 rounded-full object-cover"
      />

      <div class="flex flex-col font-bold">
        <span class="text-semantic-surface-on-surface-variant text-semantic-sizing-label">
          {{ label }}
        </span>

        <strong class="text-semantic-sizing-body text-semantic-surface-on-surface">
          {{ author?.name }}
        </strong>
      </div>
    </div>

    <template #content>
      <div class="flex flex-col items-start gap-2 md:gap-4 text-semantic-sizing-body-sm text-semantic-surface-on-surface">
        <div class="flex items-center gap-4">
          <img
            :src="author?.image"
            class="rounded-full wh-16"
          />

          <div class="w-full text-semantic-sizing-headline-sm text-semantic-surface-on-surface font-semibold">
            {{ author?.name }}

            <p class="text-semantic-sizing-label-lg text-semantic-surface-on-surface-variant mt-1">
              {{ author?.jobTitle }}
            </p>
          </div>
        </div>

        {{ generateExcerpt(author?.profileShort ?? author?.profile, 360) }}

        <div
          v-if="!_isEmpty(author?.knownFor)"
          class="flex flex-wrap gap-2"
        >
          <V2AtomsTag
            v-for="(item, itemIndex) in author?.knownFor"
            :key="`known-for-${itemIndex}`"
            class="!text-xs"
            color="whiteb"
          >
            {{ item }}
          </V2AtomsTag>
        </div>

        <div class="w-full flex flex-col items-start gap-2 md:gap-4 pt-4 border-t-1 border-semantic-outline-variant">
          <V2AtomsButton
            :to="AUTHOR_URL"
            type="primary"
            size="x-small"
            has-icon-right
          >
            Read full profile
          </V2AtomsButton>

          <V2MoleculesAuthorSocialMediaList
            :list="author.socialMedia"
            button-size="x-small"
            class="!gap-2"
          />
        </div>
      </div>
    </template>
  </V2MoleculesPopover>
</template>

<script setup>
import _isEmpty from 'underscore/cjs/isEmpty.js'

defineOptions({
  name: 'V2MoleculesAuthorDetailsPopoverCard'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'author-details-popover-card'
  },

  author: {
    type: Object,
    default: () => ({})
  },

  label: {
    type: String,
    default: 'Written by'
  }
})

const AUTHOR_URL = trailingSlash(`/our-experts${props.author?.url}`)
</script>
